<template>
  <div>
    <el-form-item :label="$t('默认值')">
        <l-user-select  
                v-model="data.default"
                :placeholder="$t('请选择')"
            >
        </l-user-select>
    </el-form-item>
    <el-form-item :label="$t('登录者')">
        <el-switch v-model="data.isLogin" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否必填')">
        <el-switch v-model="data.required" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否多选')">
        <el-switch v-model="data.multiple" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('显示边框')">
        <el-switch v-model="data.showBorder" ></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "config-userSelect",
  props: ['data'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

